import debuglogger from '../debuglogger'

// Shared by the SSR pre-hydration snapshot (vuejs-drupal-store/store/
// index.js, reading window.__INITIAL_STATE__.somnambulistui) and the
// client post-init/reinit snapshot (somnambulist-ui/src/index.js, reading
// the live store) - same breakdown from both places so the two are
// directly comparable. Guarded by the caller checking
// process.env.DEBUG_LOGGING before calling this (not guarded internally)
// so Terser can eliminate the whole call, including every JSON.stringify
// below, when the flag is off - it can't see through an imported
// function call to know its body is otherwise a no-op.
export default function logSomnambulistState(state, label) {
  if (!state) {
    debuglogger.log(`[hydration] somnambulistui (${label}): module not present`)
    return
  }

  const clubs = state.clubs || []
  const orderTypes = state.orderTypes || {}
  const selectedProducts = state.selectedProducts || {}
  const localProducts = state.products || {}

  const orderTypeEntries = Object.entries(orderTypes)
  const totalProductRefs = orderTypeEntries.reduce((sum, [, ot]) => sum + ((ot.products || []).length), 0)
  const perClubRefs = orderTypeEntries.map(([clubid, ot]) => `${clubid}:${(ot.products || []).length}`).join(', ')

  const sizeOf = (obj) => JSON.stringify(obj).length
  const totalSize = sizeOf(state)
  const clubsSize = sizeOf(clubs)
  const orderTypesSize = sizeOf(orderTypes)
  const selectedProductsSize = sizeOf(selectedProducts)
  const localProductsSize = sizeOf(localProducts)
  // Not exact (JSON.stringify-ing each group separately double-counts
  // nothing, but does add each group's own {}/[] wrapper bytes that
  // wouldn't exist inline inside the full state) - close enough as a
  // debug signal for where the rest of the byte count is going (mostly
  // langStrings + countryOptions/provinceOptions, which are static
  // reference data, not clubs/selections/products).
  const otherSize = totalSize - clubsSize - orderTypesSize - selectedProductsSize - localProductsSize

  debuglogger.log(
    `[hydration] somnambulistui (${label}): ` +
    `clubs=${clubs.length} (${clubsSize}b), ` +
    `orderTypes=${orderTypeEntries.length} types / ${totalProductRefs} product refs {${perClubRefs}} (${orderTypesSize}b), ` +
    `selections=${Object.keys(selectedProducts).length} (${selectedProductsSize}b), ` +
    `local-only products=${Object.keys(localProducts).length} (${localProductsSize}b), ` +
    `other (langStrings/countryOptions/etc)=${otherSize}b, total=${totalSize}b`
  )
}
